export default "__VITE_ASSET__DOdeTB6h__"